import { BadgeCheck } from 'lucide-react';

export interface CardRibbonProps {
  label: string;
}

export function CardRibbon({ label }: CardRibbonProps) {
  return (
    <div className="flex h-[42px] items-center gap-2 bg-accent px-4">
      <BadgeCheck aria-hidden className="size-6 text-accent-foreground" />
      <span className="typography-text-bold text-accent-foreground">{label}</span>
    </div>
  );
}
